import React, { useState, useEffect, Component, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import Pagination from '../pagination/pagination';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import { AiOutlinePrinter } from "react-icons/ai";
import * as XLSX from 'xlsx';

const StockTake = () => {
    const [rowData, setRowData] = useState([]);
    const [hideZeroAmount, setHideZeroAmount] = useState(false);
    const [allRowData, setAllRowData] = useState([]);
    const currentDatetimeUTC = new Date().toISOString();
    const [loading, setLoading] = useState(false);
    const [serloading, setSerLoading] = useState(false);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [refNoList, setRefNoList] = useState([]);
    const [Location, setLocation] = useState([]);
    const todayDate = new Date().toISOString().substr(0, 10);
    const gridRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL
    const [selectedItems, setSelectedItems] = useState([]);
    const apiService = new ApiService();
    const fileInputRef = useRef(null);
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [formData, setFormData] = useState({
        category: [{ label: 'Select Category', value: '0' }],
        wareHouse: [{ label: 'Select WareHouse', value: '0' }],
        refNo: [{ label: 'Ref No', value: '0' }],
        date: todayDate,
    });
    debugger
    const Comparison = [
        { headerName: 'Item No', field: 'itemNo', width: 150, suppressMovable: true, filter: true, floatingFilter: true },
        { headerName: 'Description', field: 'itemDescription', width: 250, suppressMovable: true, filter: true, floatingFilter: true },
        { headerName: 'UOM', field: 'unitMeasurement', width: 180, suppressMovable: true, filter: true, floatingFilter: true },
        { headerName: 'Actual Qty', field: 'qty', width: 180, suppressMovable: true, filter: true, floatingFilter: true },
        { headerName: 'Availability QTY', field: 'availableQty', editable: true, width: 180, suppressMovable: true, filter: true, floatingFilter: true },
        { headerName: 'Variance', field: 'variance', width: 150, suppressMovable: true, filter: true, floatingFilter: true },
        { headerName: 'Unit Price', field: 'unitPrice', width: 160, suppressMovable: true, },
        { headerName: 'Variance Amount', field: 'varianceAmount', width: 180, suppressMovable: true, filter: true, floatingFilter: true },
        { headerName: 'Remarks', field: 'comments', width: 150, editable: true, suppressMovable: true, filter: true, floatingFilter: true },
    ]
    useEffect(() => {
        fetchDropdownData();
        fetchItem()
    }, []);
    const fetchDropdownData = async () => {
        try {
            let Catparam = `?Active=1`;
            let wareparam = `?Exp3=1`
            const categoryResponse = await apiService.getApiParamater("GET_CATEGORY", Catparam);
            let res = await apiService.getApiParamater('GET_WAREHOUSE_MASTER', wareparam)
            setCategoryOptions(categoryResponse?.data?.result);
            setLocation(res?.data?.result)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    }
    const fetchItem = async () => {
        try {
            let refRes = await apiService.get('REF_LIST')
            setRefNoList(refRes?.data?.result)
        } catch (error) {
            console.error(error.refRes.data.message)
        }

    }
    const getItems = async () => {
        try {
            setSerLoading(true);
            const apiService = new ApiService();

            if (!formData?.category?.value?.catCode) {
                toast.warning("select Category")
                setSerLoading(false);
                return
            } else if (!formData?.wareHouse?.label) {
                toast.warning("select WareHouse")
                setSerLoading(false);
                return
            }
            const params = new URLSearchParams();
            params.append('PageNo', 1);
            params.append('PageSize', pageSize || 20);
            params.append('Category', formData.category.value.catCode);
            params.append('Warehouse', formData.wareHouse.label);
            const res = await apiService.getApiParamater('GET_STOCK_TAKE', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            if (res.status === 400) {
                setRowData([]);
                setAllRowData([]);
                setSerLoading(false);
            } else {
                setRowData(res?.data || []);
                setAllRowData(res?.data || []);
                setSerLoading(false);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
            setAllRowData([]);
            setRowData([]);
            setSerLoading(false);
        }
    }
    const handleCatChange = (selectedOption) => {
        setFormData({ ...formData, category: selectedOption });
    }
    const handleRefChange = async (selectedOption) => {
        setFormData({ ...formData, refNo: selectedOption });
        const params = new URLSearchParams();
        params.append('SNo', selectedOption.label);
        const res = await apiService.getApiParamater('REF_LIST_DETAILS', `?${params.toString()}`);
        if (res.status === 400) {
            setRowData([]);
            setAllRowData([]);
            setLoading(false);
        } else {
            setRowData(res?.data?.result || []);
            setAllRowData(res?.data?.result || []);
            setLoading(false);
        }
    }
    const handleWareHouseFilter = (selectedOption) => {
        setFormData({ ...formData, wareHouse: selectedOption });
    }
    const handleAvailQty = async (event) => {
        const editedRow = rowData.find(row => row.itemNo === event.data.itemNo);
        if (!editedRow) return;

        if (event.colDef.field === 'comments') {
            editedRow.comments = event.value;
        } else if (event.colDef.field === 'availableQty') {
            if (editedRow.qty === 0) {
                toast.warning('Quantity is not available');
                return;
            }
            if (event.value > editedRow.qty) {
                toast.warning("Available Qty must be less then or equal to Actual Qty")
                return;
            }
            editedRow[event.colDef.field] = event.value;
            editedRow.variance = editedRow.qty - event.value;
            editedRow.varianceAmount = editedRow.variance * editedRow.unitPrice;
        }
        setRowData(prevData =>
            prevData.map(row => (row.itemNo === editedRow.itemNo ? { ...editedRow } : row))
        );
        setSelectedItems(prevItems => {
            const updatedItems = [...prevItems];
            const existingItemIndex = updatedItems.findIndex(item => item.rcNo === editedRow.rcNo);
            if (existingItemIndex !== -1) {
                updatedItems[existingItemIndex] = { ...updatedItems[existingItemIndex], ...editedRow };
            } else {
                const existingItem = prevItems.find(item => item.rcNo === editedRow.rcNo);
                updatedItems.push({ ...existingItem, ...editedRow });
            }
            return updatedItems;
        });
    }
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const onBtnCSVExport = useCallback(() => {
        if (!gridRef.current?.api) return;

        gridRef.current.api.exportDataAsCsv({
            fileName: `${formData?.wareHouse?.label}/${todayDate}.csv`,
            prependContent: [
                [
                    { data: { value: `Category: ${formData?.category?.label || ''}` } },
                    { data: { value: `Warehouse: ${formData?.wareHouse?.label || ''}` } },
                ],
                [
                    { data: { value: '' } },
                ],
            ],
        });
    }, [formData]);
    const onBtPDFExport = () => {
        const doc = new jsPDF('p', 'mm', 'a4');

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor('#6e5199');

        doc.text('Stock Take Report', 14, 15);

        doc.setFontSize(10);
        doc.setTextColor('#000');
        doc.text(`Category: ${formData?.category?.label || ''}`, 14, 22);
        doc.text(`Warehouse: ${formData?.wareHouse?.label || ''}`, 14, 28);
        doc.text(`Date: ${formData?.date || ''}`, 14, 34);

        const columns = Comparison.map(col => col.headerName);
        const fields = Comparison.map(col => col.field);

        const rowDataArray = [];
        gridRef.current.api.forEachNode((node) => {
            rowDataArray.push(fields.map(field => node.data?.[field] ?? ''));
        });

        doc.autoTable({
            head: [columns],
            body: rowDataArray,
            startY: 40,
            theme: 'grid',
            headStyles: {
                fillColor: '#6e5199',
                textColor: '#ffffff',
                fontSize: 8,
                fontStyle: 'bold',
            },
            alternateRowStyles: {
                fillColor: '#f2eafc',
            },
            styles: {
                fontSize: 8,
                cellPadding: 2,
            },
        });

        doc.save('StockTake.pdf');
    }
    const handleReset = () => {
        // Clear grid
        setRowData([]);
        setAllRowData([]);

        // Reset filters
        setHideZeroAmount(false);

        // Clear uploaded file
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }

        // Reset form
        setFormData({
            category: { label: 'Select Category', value: '0' },
            wareHouse: { label: 'Select WareHouse', value: '0' },
            refNo: { label: 'Ref No', value: '0' },
            date: todayDate,
        });
    }
    const handleSave = async () => {
        setLoading(true);
        if (formData?.refNo?.label) {
            setLoading(false);
            return;
        } else {
            const editedRows = rowData.filter(row => row.availableQty && row.qty !== undefined);
            const itemsWithVariance = rowData.filter(row => row.variance !== undefined);
            if (editedRows.length === 0) {
                toast.warning("At least one item must have a variance.");
                setLoading(false);
                return;
            }
            if (itemsWithVariance.length === 0) {
                toast.warning("At least one item must have a variance.");
                setLoading(false);
                return;
            }
            for (const item of editedRows) {

                if (parseInt(item.availableQty) > item?.qty) {
                    toast.warning(`Available Qty ${item?.itemDescription} must be less then or equal to Actual Qty`);
                    setLoading(false);
                    return;
                }
            }
            try {
                const currentDatetimeUTC = new Date().toISOString();
                const requestBody = {
                    tranDate: formData.date,
                    modifiedBy: userName,
                    mode: "new",
                    itemStockTypes: rowData.map(row => ({
                        recordId: 0,
                        itemNo: row.itemNo,
                        description: row.itemDescription,
                        location: formData.wareHouse.label || formData.wareHouse[0].label,
                        uom: row.unitMeasurement,
                        actualQuantity: row.qty,
                        quantity: parseInt(row.availableQty),
                        variance: row.variance,
                        remarks: row.comments || '',

                        takenBy: "",
                        takenDate: currentDatetimeUTC,
                        checked: false,
                        checkedBy: "",
                        checkedDate: currentDatetimeUTC,
                        checkedRemarks: "",
                        approved: false,
                        approvedBy: "",
                        approvedDate: currentDatetimeUTC,
                        approvedRemarks: "",
                        status: "0",
                        exp1: "",
                        exp2: "",
                        exp3: "",
                        exp4: "",
                        exp5: ""
                    }))
                };

                try {
                    const response = await apiService.post("UPDATE_STOCK_TAKE", requestBody);
                    if (response.data.statusCode === 201) {
                        let docNumber = response.data.result.stockAdjustmentNo
                        const userData2 = {
                            docType: "Stock Adjustment",
                            docId: docNumber ? docNumber.toString() : docNumber,
                            department: "IT",
                            company: Company?.selectedCompany?.companyNo,
                            userCode: userId,
                            userName: userName,
                        };
                        const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                        const paramsGet = new URLSearchParams();
                        paramsGet.append('docType', "Stock Adjustment");
                        paramsGet.append('docId', docNumber);
                        paramsGet.append('srno', 1);
                        const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                        if (response3?.data?.result.length > 0) {
                            const toEmails = response3?.data?.result?.map(user => user.userEmail);
                            const emailbody = {
                                toEmails: toEmails,
                                subject: "Stock Type",
                                body: "",
                                docNo: docNumber,
                                srNo: 1,
                                docType: "Stock Adjustment"
                            };
                            const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                        }
                        if (response.data.statusCode === 201) {
                            let docNumber = response.data.result.stockAdjustmentNo;
                            const token = localStorage.getItem("Token");
                            const DB = localStorage.getItem("DataBase")
                            // if (!formData?.wareHouse?.label || formData[0]?.wareHouse?.label) {
                            //     toast.warning("select WareHouse")
                            //     setLoading(false);
                            //     return
                            // } else 
                            if (!docNumber) {
                                toast.warning("select RefNo")
                                setLoading(false);
                                return
                            }
                            if (!token) {
                                alert("Auth token is missing! Unable to proceed.");
                                setLoading(false);
                                return;
                            }
                            const popupWidth = 1000;
                            const popupHeight = 600;
                            const popupLeft = (window.screen.width - popupWidth) / 2;
                            const popupTop = (window.screen.height - popupHeight) / 2;
                            const popup = window.open(
                                "",
                                "ReportPopup",
                                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                            );

                            if (popup) {
                                const form = document.createElement("form");
                                form.method = "POST";
                                form.action = REPORT_URL;
                                form.target = "ReportPopup";

                                const inputs = [
                                    { name: "authToken", value: token },
                                    { name: "_db", value: DB },
                                    { name: "reportName", value: "StockTake" },
                                    { name: "voucherNo", value: docNumber },
                                    { name: "TranDate", value: formData?.date },
                                    { name: "Location", value: formData?.wareHouse?.label || formData?.wareHouse[0]?.label },
                                ];

                                inputs.forEach(({ name, value }) => {
                                    const input = document.createElement("input");
                                    input.type = "hidden";
                                    input.name = name;
                                    input.value = value;
                                    form.appendChild(input);
                                });

                                document.body.appendChild(form);
                                form.submit();
                                document.body.removeChild(form);
                            }
                            fetchItem()
                            toast.success("Stock take saved successfully!");
                            setLoading(false);
                            handleReset()
                        } else {
                            setLoading(false);
                            toast.error("Error saving stock take!");
                        }
                    }
                } catch (error) {
                    setLoading(false);
                    console.error("Error updating stock take:", error);
                }
            } catch (error) {
                setLoading(false);
                console.error("Error saving stock take:", error);
                toast.error("An error occurred while saving stock take.");
            }
        }
    }
    const handlePrint = () => {
        const gridElement = document.querySelector('.ag-theme-quartz');

        if (!gridElement) return;

        const columnHeaders = Array.from(gridElement.querySelectorAll('.ag-header-cell'))
            .map(header => header.innerText.trim());

        const rowData = Array.from(gridElement.querySelectorAll('.ag-row')).map(row => {
            return Array.from(row.querySelectorAll('.ag-cell')).map(cell => cell.innerText.trim());
        });

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
            <head>
            <title>Stock Item</title>
                <style>
                    body {
                        margin: 20px;
                        padding: 10px;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 10px;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 8px;
                        text-align: left;
                        font-size: 12px;
                        white-space: nowrap;
                    }
                    th {
                        background-color: #6e5199;
                        color: #ffffff;
                        font-weight: bold;
                        text-transform: uppercase;
                    }
                    tr:nth-child(even) {
                        background-color: #f2eafc;
                    }
                    tr:nth-child(odd) {
                        background-color: #ffffff;
                    }
                    @media print {
                        body {
                            margin: 10px;
                            padding: 0;
                        }
                        table {
                            page-break-inside: auto;
                        }
                        tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
                    }
                </style>
            </head>
            <body>
                <h5 style="text-align: center; margin-bottom: 15px;">Category : ${formData?.category?.label} || WareHouse : ${formData?.wareHouse?.label}</h5>
                <table>
                    <thead>
                        <tr>${columnHeaders.map(header => `<th>${header}</th>`).join('')}</tr>
                    </thead>
                    <tbody>
                        ${rowData.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
                    </tbody>
                </table>
                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(() => window.close(), 1000);
                    };
                </script>
            </body>
            </html>
        `);

        printWindow.document.close();
    }
    const handlePrintReport = (data) => {
        const token = localStorage.getItem("Token");
        const DB = localStorage.getItem("DataBase")
        if (!formData?.wareHouse?.label) {
            toast.warning("select WareHouse")
            return
        } else if (!formData?.refNo?.label) {
            toast.warning("select RefNo")
            return
        }
        if (!token) {
            alert("Auth token is missing! Unable to proceed.");
            return;
        }
        const popupWidth = 1000;
        const popupHeight = 600;
        const popupLeft = (window.screen.width - popupWidth) / 2;
        const popupTop = (window.screen.height - popupHeight) / 2;
        const popup = window.open(
            "",
            "ReportPopup",
            `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
        );

        if (popup) {
            const form = document.createElement("form");
            form.method = "POST";
            form.action =
                REPORT_URL;
            form.target = "ReportPopup";


            const inputs = [
                { name: "authToken", value: token },
                { name: "_db", value: DB },
                { name: "reportName", value: "StockTake" },
                { name: "voucherNo", value: formData?.refNo?.label },
                { name: "TranDate", value: formData?.date },
                { name: "Location", value: formData?.wareHouse?.label },
            ];

            inputs.forEach(({ name, value }) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = name;
                input.value = value;
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        }
    }
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (event) => {
            const text = event.target.result;

            const rows = text
                .split('\n')
                .map(r => r.trim())
                .filter(r => r.length);

            /* ---------------------------
               🔹 READ CATEGORY & WAREHOUSE
            ---------------------------- */
            const firstRow = rows[0].split(',');

            let category = '';
            let warehouse = '';
            firstRow.forEach(col => {
                const value = col.replace(/"/g, '').trim();

                if (value.toLowerCase().startsWith('category:')) {
                    category = value.split(':')[1].trim();
                }

                if (value.toLowerCase().startsWith('warehouse:')) {
                    warehouse = value.split(':')[1].trim();
                }
            });

            setFormData(prev => ({
                ...prev,
                category: [{ label: category, value: category }],
                wareHouse: [{ label: warehouse, value: warehouse }],
                refNo: [{ label: 'Ref No', value: '0' }],
                date: todayDate,
            }));

            /* ---------------------------
               🔹 FIND HEADER ROW
            ---------------------------- */
            const headerIndex = rows.findIndex(row =>
                row.toLowerCase().includes('item no')
            );

            if (headerIndex === -1) return;

            const headers = rows[headerIndex]
                .split(',')
                .map(h => h.replace(/"/g, '').trim());

            const dataRows = rows.slice(headerIndex + 1);

            const parsedData = dataRows.map(row => {
                const values = row
                    .split(',')
                    .map(v => v.replace(/^"|"$/g, ''));

                const record = {};
                headers.forEach((h, i) => {
                    record[h] = values[i] ?? '';
                });

                const qty = Number(record['Actual Qty']) || 0;
                const availableQty = Number(record['Availability QTY']) || 0;
                const unitPrice = Number(record['Unit Price']) || 0;

                const variance =
                    record['Availability QTY'] !== undefined && record['Availability QTY'] !== ''
                        ? qty - availableQty
                        : Number(record['Variance']) || 0;

                const varianceAmount = record['Availability QTY'] !== undefined && record['Availability QTY'] !== ''
                    ? variance * unitPrice
                    : Number(record['Variance Amount']) || 0;
                return {
                    itemNo: record['Item No'],
                    itemDescription: record['Description'],
                    unitMeasurement: record['UOM'],
                    qty,
                    availableQty,
                    variance,
                    unitPrice,
                    varianceAmount,
                    comments: record['Remarks'] || '',
                };
            });

            debugger
            setAllRowData(parsedData);
            setRowData(parsedData);
        };

        reader.readAsText(file);
    }

    return (
        <div className='px-4 pb-5'>
            <div className='border-box2 p-4 py-3 mt-4'>
                <div className=' d-flex justify-content-between'>
                    <h5 className='col mainInvHead'>Stock Take</h5>
                    <div className='d-flex gap-3'>
                        {loading === true ?
                            <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <button className='mainbtn ' style={!formData?.refNo?.label ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} type="submit" onClick={handleSave}><FaSave className='center mt-1 mx-2' /><div>Save</div></button>
                        }
                        {serloading === true ?
                            <button className='mainbtnGry ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <button className='mainbtnGry ' type="submit" onClick={getItems}><FaSave className='center mt-1 mx-2' /><div>Search</div></button>
                        }
                        <button className='mainbtnRed' onClick={handleReset} ><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    </div>
                </div>
                <div className='row d-flex justify-content-between mt-4'>
                    <div className='col'>
                        <Select
                            value={formData?.category}
                            onChange={(selectedOption) => handleCatChange(selectedOption)}
                            options={categoryOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.catName }))}
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className='col'>
                        <input
                            type='date'
                            className="form-Input w-100"
                            id="validationCustom02" name='date'
                            onChange={handleInputChange}
                            value={formData.date}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            value={formData?.wareHouse}
                            onChange={(selectedOption) => handleWareHouseFilter(selectedOption)}
                            options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            value={formData?.refNo}
                            onChange={(selectedOption) => handleRefChange(selectedOption)}
                            options={refNoList?.map((ref) => ({ value: ref, label: ref?.sNo }))}
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                        />
                    </div>
                </div>
                <div className='row d-flex mt-4'>
                    <div className="col-3 d-flex align-items-center gap-2 px-2">
                        <input
                            type="checkbox"
                            style={{ width: "20px", height: "20px" }}
                            checked={hideZeroAmount}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setHideZeroAmount(checked);
                                if (checked) {
                                    setRowData(allRowData.filter(r => Number(formData?.refNo?.label === "Ref No" || formData?.refNo[0]?.label === "Ref No" ? r.qty : r.availableQty) !== 0));
                                } else {
                                    setRowData(allRowData);
                                }
                            }}
                        />
                        <label className="mb-0">Hide Zero Qty</label>
                    </div>
                    <div className='col-3'>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".csv,.xlsx,.xls"
                            onChange={handleFileUpload}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Items List</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                {/* <DropdownItem onClick={onBtExcelExport} className='gap-3 d-flex center'><LiaFileExcel/><div>Export Excel</div></DropdownItem> */}
                                <DropdownItem onClick={onBtPDFExport} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div className='mainbtnRed flex-end ' onClick={handlePrint}>
                        <HiOutlinePrinter size={25} style={{ cursor: "pointer" }} />
                    </div>

                    <div
                        onClick={handlePrintReport}
                        className={`mainbtnRed flex-end gap-2`}
                    >
                        <AiOutlinePrinter color='#fff' className='center mt-1 ' />
                        <div className='center'>Print Report</div>
                    </div>
                    {/* <div className='mainbtn flex-end gap-1'>
                        <div className='center'><TfiEmail size={25} /></div>
                    </div> */}
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 600 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        rowData={rowData}
                        rowSelection={'single'}
                        columnDefs={Comparison}
                        onCellValueChanged={handleAvailQty}
                        singleClickEdit={true}
                        ref={gridRef}
                        stopEditingWhenCellsLoseFocus={true}
                    />
                </div>
            </div>
            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
        </div>
    );
};
export default StockTake;